import { Component, OnInit } from '@angular/core';
import { WinService } from 'src/app/services/win.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

	/**
	 * use for features icon and background
	 */
	featureIcon: string = '';
	featureBG: string = 'bg-yellow';

	constructor(
		public winService: WinService,
		public lang: LangService,
		public cms: CmsService
	) { }

	ngOnInit() {
		this.cms.getBlock(1);
	}
}
